import { DeviceInfo } from '../auth/common/configuration/DeviceInfoTypes'

const isObject = (val: unknown): val is Record<string, unknown> => {
  return val !== null && typeof val === 'object' && !Array.isArray(val)
}

const isFinite = (val: unknown): val is number => {
  return typeof val === 'number' && Number.isFinite(val)
}

export class DefaultDeviceInfo {
  static get(): Partial<DeviceInfo> {
    const defaultDeviceInfo: Partial<DeviceInfo> = {}
    Object.assign(defaultDeviceInfo, DefaultDeviceInfo.getNavigatorInfo())
    Object.assign(defaultDeviceInfo, DefaultDeviceInfo.getScreenInfo())
    return defaultDeviceInfo
  }

  static getNavigatorInfo(): Partial<DeviceInfo> {
    const navigatorInfo: Partial<DeviceInfo> = {}

    if (typeof navigator !== 'undefined' && isObject(navigator)) {
      navigatorInfo.userAgent = navigator.userAgent

      // This API is kind of trash. In chrome my WiFi identifies as '4g'
      // @ts-expect-error - Only available on chromium browsers
      // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
      const connection = navigator.connection
      if (connection) {
        const { type, effectiveType } = connection as Record<string, any>
        switch (type) {
          case 'wifi':
            navigatorInfo.connectionType = 'WiFi'
            break
          case 'ethernet':
            navigatorInfo.connectionType = 'LAN'
            break
          default:
            if (effectiveType) {
              navigatorInfo.connectionType = effectiveType
            }
            break
        }
      }
    }
    return navigatorInfo
  }

  static getScreenInfo(): Partial<DeviceInfo> {
    const screenInfo: Partial<DeviceInfo> = {}

    if (typeof screen !== 'undefined' && isObject(screen)) {
      const { width, height } = screen
      if (isFinite(width) && isFinite(height) && width * height > 200) {
        const pixelRatio = isFinite(devicePixelRatio) && devicePixelRatio || 1
        const pixelWidth = width * pixelRatio
        const pixelHeight = height * pixelRatio
        const ppi = 96 * pixelRatio
        const horizontal = pixelWidth / ppi
        const vertical = pixelHeight / ppi
        const diagonal = Math.sqrt(horizontal ** 2 + vertical ** 2)
        screenInfo.displayWidth = pixelWidth.toFixed(2)
        screenInfo.displayHeight = pixelHeight.toFixed(2)
        screenInfo.displayPpi = ppi.toFixed(2)
        screenInfo.diagonalScreenSize = diagonal.toFixed(2)
      }
    }
    return screenInfo
  }

  constructor() {
    return DefaultDeviceInfo.get()
  }
}

